<template>
  <div>
    <form role="form">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                Affichage à l'écran
              </h3>

            </div>
            <form method="POST" action="" @submit.prevent="refreshListing()">
              <div class="box-body">
                <div class="row">
                  <div class="col-md-12">
                    <label>A afficher :</label>
                    <div class="form-group">
                      <label class="checkbox-inline">
                        <input id="memberLicencies" type="checkbox"
                               v-model="show.memberLicencies">
                        Membres licenciés
                      </label>
                      <label class="checkbox-inline">
                        <input id="memberNotLicencies" type="checkbox"
                               v-model="show.memberNotLicencies">
                        Membres non-licenciés
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row" style="margin-top: 25px;">
                  <div class="col-md-12">
                    <label>Dates à afficher :</label>
                    <div class="form-group">
                      <label class="checkbox-inline" v-for="annee in anneesDispo()">
                        <input :id="'anneeToShow'+annee" :value="annee" type="checkbox"
                               v-model="show.annees">
                        31/12/{{ annee }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 25px;">
                  <div class="col-md-12">
                    <label>Filtres sur les anciens membres :</label>
                    <div class="form-group">
                      <label class="checkbox-inline">
                        <input id="showDoublons" type="checkbox"
                               v-model="show.showDoublons">
                        Afficher les doublons pour chaque année
                      </label>
                      <label class="checkbox-inline">
                        <input id="notLicenciedToday" type="checkbox"
                               v-model="show.notLicenciedToday">
                        Afficher uniquement les non-licenciés le {{ currentYear() }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-footer">
                <input type="submit" value="Rechercher" class="btn btn-primary pull-right"/>
              </div>
            </form>
          </div>
        </div>
      </div>
    </form>

    <form role="form">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="overlay" v-if="loadingTableBox">
              <i class="fa fa-refresh fa-spin"></i>
            </div>

            <div class="box-header with-border">
              <h3 class="box-title">Membres: ({{ licencesQueried.length }} résultats / {{
                  licencesQueried.length -
                  nombreDoublons
                }} doublons)</h3>


              <div class="btn-group pull-right">
                <button @click.prevent="exportCSV()" type="button" class="btn btn-primary"
                        :disabled="licencesChecked.length==0" :class="{'disabled':licencesChecked.length==0}">Exporter
                  en XLS/CSV (Excel)
                </button>
                <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"
                        :disabled="licencesChecked.length==0" :class="{'disabled':licencesChecked.length==0}">
                  <span class="caret"></span>
                  <span class="sr-only">Dropdown</span>
                </button>
                <ul class="dropdown-menu dropdown-menu-abft" role="menu">
                  <li><a @click.prevent="exportCSV()">Exporter en XLS/CSV (Excel)</a></li>
                  <li><a @click.prevent="exportDemandeLicence()">Exporter les demandes de licences
                    {{ moment().year() }}</a></li>
                  <!--<li><a href="#">Exporter en PDF</a></li>-->
                  <!--<li><a href="#">Exporter en PDF pour courrier communal</a></li>-->
                </ul>
              </div>

              <div class="btn-group margin-r-5 pull-right">
                <button :disabled="licencesQueried.length==0" :class="{'disabled':licencesQueried.length==0}"
                        @click.prevent="selectAll()" type="button" class="btn btn-default">Sélectionner tout
                </button>
                <button :disabled="licencesQueried.length==0" :class="{'disabled':licencesQueried.length==0}"
                        type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">
                  <span class="caret"></span>
                  <span class="sr-only">Dropdown</span>
                </button>
                <ul class="dropdown-menu" role="menu">
                  <li><a @click.prevent="selectAll()">Sélectionner tout</a></li>
                  <li><a @click.prevent="deselectAll()">Déselectionner tout</a></li>
                </ul>
              </div>
            </div>
            <div class="box-body">
              <table v-if="true" id="licencesMembresOfClub"

                     class="table table-hover table-striped table-bordered">
                <thead>
                <tr>
                  <th></th>
                  <th>Licence</th>
                  <th>Nom</th>
                  <th>Prénom</th>
                  <th>Téléphone</th>
                  <th>Mail</th>
                  <th>Date d'encodage</th>
                  <th>Facture</th>
                  <th>Date de début</th>
                  <th>Date de fin</th>
                  <th>Statut</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="licence in licencesQueried">
                  <td><input type="checkbox" :value="licence.id" v-model="licencesChecked"></td>
                  <td>{{ licence.id }}</td>

                  <td>
                    <router-link :to="{ name: 'Member', params: { member_id: licence.membre.id }}">{{
                        licence.membre.nom
                      }}
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="{ name: 'Member', params: { member_id: licence.membre.id }}">{{
                        licence.membre.prenom
                      }}
                    </router-link>
                  </td>
                  <td>{{ licence.membre.phoneContact }}</td>
                  <td><a :href="'mailto:'+licence.membre.mail"></a>{{ licence.membre.mail }}</td>
                  <td :data-order="getTimeStamp(licence.created_at)">{{ formatDate(licence.created_at, 'YYYY-MM-DD', 'DD/MM/YYYY') }}</td>
                  <td v-if="licence.id_recapitulatif!=0">
                    <router-link :to="{name: 'Recap', params: { recap_id: licence.id_recapitulatif }}">
                      {{ licence.id_recapitulatif }}
                    </router-link>
                  </td>
                  <td v-if="licence.id_recapitulatif==0">
                    <span class="text-red">PAS DE RECAPITULATIF</span>
                  </td>
                  <td :data-order="getTimeStamp(formatDate(licence.date_debut,'DD/MM/YYYY','YYYY-MM-DD'))">{{
                      licence.date_debut
                    }}
                  </td>
                  <td :data-order="getTimeStamp(formatDate(licence.date_fin,'DD/MM/YYYY','YYYY-MM-DD'))">{{
                      licence.date_fin
                    }}
                  </td>
                  <td v-if="licence.membre.isLicencie"><span class="text-green">Licencié au {{ currentYear() }}</span>
                  </td>
                  <td v-if="!licence.membre.isLicencie"><span class="text-red">Non-licencié au {{ currentYear() }}</span>
                  </td>
                  <td>
                    <button @click.prevent="" class="btn btn-box-tool">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button @click.prevent="" class="btn btn-box-tool">
                      <i class="fa fa-remove"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';

import vueTableListingMembreInClub from '../../VueTable/configs/vueTableListingMembreInClub'

var $ = require('jquery');
var variables = require('../../../assets/js/variables')
var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');

export default {
  data() {
    return {
      licencesQueried: [],
      licencesChecked: [],
      nombreDoublons: 0,
      dataTable: null,
      loadingTableBox: false,
      show: {
        notLicenciedToday: false,
        showDoublons: false,
        annees: [moment().year()],
        memberLicencies: true,
        memberNotLicencies: true
      }
    }
  },
  computed: {
    ...mapGetters({
      getClub: 'getClub',
      getRoute: 'getRoute',
    }),

  },
  methods: {
    ...mapActions({}),

    getTimeStamp: function (date) {
      return moment(date).valueOf()
    },
    selectAll: function () {
      this.licencesChecked = [];
      this.licencesChecked = this.licencesQueried.map(function (item) {
        return item.id
      });
    },
    deselectAll: function () {
      this.licencesChecked = [];
    },
    moment: function () {
      return moment()
    },
    exportDemandeLicence: function (year = null) {
      if (this.licencesChecked.length <= 0)
        return;
      if (!year)
        year = moment().year();
      let these = this;
      this.loadingTableBox = true
      this.$http.post
      (
        this.getRoute('Secretariat.demandeLicenceMultiple'),
        JSON.stringify({"ids_licences": this.licencesChecked, "year": year}),
        {responseType: 'blob'}
      ).then(function (response) {
        this.loadingTableBox = false
        let type=this.licencesChecked.length == 1 ? {type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"}:{type: "application/zip"}
        let extension=this.licencesChecked.length == 1 ? ".docx":".zip"
        var blob = new Blob([response.body],type);
        FileSaver.saveAs(blob, "Demandes_licence_" + these.getClub.id + extension);
        return response.blob();
      }, (response) => {
        these.$noty.error("Erreur dans la génération des demandes de licence")
        this.loadingTableBox = false
      });
    },
    exportCSV: function () {
      if (this.licencesChecked.length <= 0)
        return;
      let these = this;
      this.loadingTableBox = true
      this.$http.post(this.getRoute('exportListingMembresXLS'), JSON.stringify({selection: this.licencesChecked}), {responseType: 'blob'})
        .then(function (response) {
          var blob = new Blob([response.body], {type: 'application/vnd.ms-excel'});
          FileSaver.saveAs(blob, "exportListingMembres.xls");
          this.loadingTableBox = false
          return response.blob();
        }, (response) => {
          these.$noty.error("Erreur dans la génération de l'export")
          this.loadingTableBox = false
        });
    },
    setDoublons: function () {
      let result = {}
      this.licencesQueried.forEach(function (item, index, array) {
        result[item.id_membre] = true
      })
      this.nombreDoublons = _.keys(result).length
    },
    currentYear: function () {
      return moment().format("DD/MM/YYYY");
    },
    anneesDispo: function () {
      let annees = _.sortBy(this.getClub.licences, 'annee');
      annees = annees.map(function (item, index, array) {
        return +item.annee
      })
      // debugger
      if (_.indexOf(annees, +(moment().format('Y'))) < 0)
        annees.push(+(moment().format('Y')))
      return _.uniq(annees)
    },
    constructForm: function () {
      return JSON.stringify({
        "id_club": this.getClub.id,
        "notLicenciedToday": this.show.notLicenciedToday,
        "showDoublons": this.show.showDoublons,
        "annees": this.show.annees,
        "memberLicencies": this.show.memberLicencies,
        "memberNotLicencies": this.show.memberNotLicencies,
      })
    },
    formatDate: function (value, ftmIn, fmtOut) {
      if (value == null) return ''
      fmtOut = (typeof fmtOut == 'undefined') ? 'DD/MM/YYYY HH:mm' : fmtOut
      return moment(value, ftmIn).format(fmtOut)
    },
    refreshListing: function () {
      var these = this
      let loadingGood = false
      this.$http.post(this.getRoute('Secretariat.club.listingMembre'), this.constructForm()).then(function (response) {
        // this.$refs.vuetable.refresh()
        these.disabledBtn = false
        these.dataTable = $("#licencesMembresOfClub").DataTable();
        these.dataTable.destroy();
        these.licencesQueried = Object.values(response.body);
        these.licencesChecked = [];
        these.setDoublons();
        loadingGood = true
      }, (response) => {
        these.$noty.error("Erreur la requête pour le listing des membres")
        these.disabledBtn = false
        loadingGood = false
      }).then(function () {
        if (loadingGood)
          these.dataTable = $("#licencesMembresOfClub").DataTable({
            language: variables.dt_french(),
            "paging": true,
            "ordering": true,
            "info": true,
            "autoWidth": true,
          });
      })
    }
  },
  watch: {},

  mounted: function () {
    var these = this
    this.getClub.licencesQueried = [];
    these.dataTable = null;
    this.$nextTick(function () {
      these.refreshListing();
    })
  },
  filters: {},
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Club/ListingMembres.vue